import SectionHeading from "@/components/base/SectionHeading";
import { clips } from "@/mocks/clips";

const rowColors = [
  "bg-background-200 text-foreground-800",
  "bg-secondary-100 text-secondary-900",
  "bg-primary-100 text-primary-800",
  "bg-accent-100 text-accent-900",
];

export default function DanmakuWall() {
  const pool = clips.flatMap((clip) => clip.danmaku);
  const rows = [0, 1, 2, 3].map((rowIndex) =>
    pool.filter((_, i) => i % 4 === rowIndex).slice(0, 8)
  );

  return (
    <section className="bg-background-100" id="danmaku">
      <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          align="center"
          eyebrow="弹幕热议"
          title="弹幕替你说出了当时的心情"
          description="我们把片段对应时间段内互动最集中的弹幕单独抽出来，让你不用翻完整场，也能感受到现场气氛。"
        />

        <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
          <div className="flex flex-col gap-3">
            {rows.map((row, rowIndex) => (
              <div key={rowIndex} className="relative h-9 overflow-hidden">
                <div className="bolao-danmaku-line flex w-max items-center gap-3">
                  {row.map((item) => (
                    <span
                      key={`${rowIndex}-${item.id}`}
                      className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-label ${rowColors[rowIndex]}`}
                    >
                      {item.user}：{item.text}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-6 text-center font-body text-xs text-foreground-500">
          弹幕内容来自公开直播间，已过滤重复与无意义刷屏，仅保留能反映现场反应的部分。
        </p>
      </div>
    </section>
  );
}